"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Icon_1 = require("../../Icon");
var Check_styles_1 = require("./Check.styles");
var getClassNames = Utilities_1.classNamesFunction();
var CheckBase = /** @class */ (function (_super) {
    tslib_1.__extends(CheckBase, _super);
    function CheckBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckBase.prototype.shouldComponentUpdate = function (newProps) {
        return this.props.checked !== newProps.checked;
    };
    CheckBase.prototype.render = function () {
        var _a = this.props, checked = _a.checked, className = _a.className, theme = _a.theme;
        var classNames = getClassNames(Check_styles_1.getStyles, { theme: theme, className: className, checked: checked });
        return (React.createElement("div", { className: classNames.root },
            React.createElement(Icon_1.Icon, { iconName: 'CircleRing', className: classNames.circle }),
            React.createElement(Icon_1.Icon, { iconName: 'StatusCircleCheckmark', className: classNames.check })));
    };
    CheckBase.defaultProps = {
        checked: false
    };
    CheckBase = tslib_1.__decorate([
        Utilities_1.customizable('Check', ['theme'])
    ], CheckBase);
    return CheckBase;
}(Utilities_1.BaseComponent));
exports.CheckBase = CheckBase;
//# sourceMappingURL=Check.base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Check/Check.base.js
// module id = 383
// module chunks = 0